import { useQuery } from '@apollo/client';
import * as R from 'ramda';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { BookmarkParentType } from '~/apollo/generated/v3/graphql';
import { graphql } from '~/apollo/generated/v4';
import { NotFound } from '~/components/common/NotFound';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { SOItemListV4 } from '~/components/supporting-object/so-item-list-v4';
import { TaggedSOItemListV4 } from '~/components/supporting-object/tagged-so-item-list-v4';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const OUTCROP_FACIES_PAGE = graphql(`
  query OutcropFaciesPage($id: ID!) {
    outcropGet(id: $id) {
      id
      facies {
        ...faciesParts
        pictures {
          ...soPictureParts
        }
      }

      studies {
        ...studyParts
        facies {
          ...faciesParts
          pictures {
            ...soPictureParts
          }
        }
      }
    }
  }
`);

export default function OutcropFaciesPage() {
  return (
    <ApolloProviderV4>
      <OutcropFaciesPageInner />
    </ApolloProviderV4>
  );
}

function OutcropFaciesPageInner() {
  const outcropId = useRouteParam('outcropId', parseInt);

  const { data, loading } = useQuery(OUTCROP_FACIES_PAGE, {
    variables: { id: outcropId },
  });

  const refetchQueries = createRefetchQueries([
    { query: OUTCROP_FACIES_PAGE, variables: { id: outcropId } },
  ]);

  const outcrop = data?.outcropGet;
  const facies = outcrop?.facies ?? [];
  const outcropStudies =
    outcrop?.studies.slice().sort(R.ascend(s => s.name)) ?? [];

  if (loading) return <SpinnerPlaceholder />;
  if (!outcrop) return <NotFound />;

  return (
    <div className="space-y-4">
      <SOItemListV4
        items={facies}
        soParentType="outcrop"
        soParentId={outcropId}
        bookmarkParentType={BookmarkParentType.Facies}
        refetchQueries={refetchQueries}
      />

      <TaggedSOItemListV4
        outcropId={outcropId}
        studies={outcropStudies}
        supportObjectKey="facies"
        refetchQueries={refetchQueries}
      />
    </div>
  );
}
